/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable @angular-eslint/relative-url-prefix */
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { combineLatest, Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';

import { AppState } from '@tsq-web/state';
import { Condo } from '@tsq-web/condo';
import { User } from '@tsq-web/users';
import { fromUserContextActions, fromUserContextSelectors } from '@tsq-web/user-context';
import { CondoService } from '../../shared/condo/condo.service';

@Injectable()
export class CondoRequiredGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private condoService: CondoService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return combineLatest([
      this.store.pipe(select(fromUserContextSelectors.selectUser)),
      this.store.pipe(select(fromUserContextSelectors.selectUserCondos)),
      this.store.pipe(select(fromUserContextSelectors.selectCondo)),
    ]).pipe(
      mergeMap(([currentUser, condos, currentCondo]) => {
        if (!!currentUser && !!currentCondo) {
          return of(true);
        }
        return this.condoService.goToCondo(route.params.condoId).pipe(
          mergeMap((user: User) => {
            const condoFound = condos.find(c => c.id === route.params.condoId);
            if (!!condoFound) {
              return of([user, condoFound]);
            }
            return this.condoService.getCondo(route.params.condoId).pipe(map(c => [user, c]));
          }),
          map(([user, condo]: [User, Condo]) => {
            this.store.dispatch(fromUserContextActions.updateUser({ user }));
            this.store.dispatch(fromUserContextActions.setCondo({ condo, suppressEvent: true }));
            return true;
          }),
          catchError(() => of(this.router.parseUrl(''))),
        );
      }),
    );
  }
}
